import styled from 'styled-components'

export const Container = styled.div<{ builderBodyHeight: number }>`
    //padding: 0 16px;
    height: 100%;
    width: 100%;

    font: 400 16px / 24px var(--font-regular);

    > .section {
        height: 100%;
    }

    .builder-body {
        height: ${({ builderBodyHeight }) => builderBodyHeight}px;

        > div {
            height: 100%;
        }

        .form-builder-section {
            padding: 24px;
            overflow-y: auto;
            border-right: 1px solid var(--gray-400);

            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }

            &::-webkit-scrollbar-track {
                background: transparent;
                border-radius: 8px;
                margin: 1px;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 8px;
                background-clip: padding-box;
                background-color: var(--beam-color-gray_300);
            }

            &::-webkit-scrollbar-thumb:hover {
                background-color: var(--gray-500);
            }

            &.properties {
                border-right: 0;
            }

            .section-header {
                margin-bottom: 16px;
                min-height: 50px;
            }
        }

        .preview {
            padding: 24px 9vw;
        }

        .preview > .preview-annotation {
            padding: 0 10px;
            border: 1px solid var(--gray-300);
            min-height: 90%;
            margin-top: 16px;

            font: 400 12px / 20px var(--font-regular);
        }
    }
`

export const HorizontalGroup = styled.div<{ padding?: string }>`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 16px;

    margin: 16px 0;

    * {
        cursor: pointer;
    }

    > div {
        border-radius: 4px;
        width: 100%;
        transition: 0.12s;
    }

    .form-group {
        margin: 0;
    }
`

export const StyledButton = styled.button<{ color: string }>`
    position: relative;
    color: ${({ color }) => color ?? 'var(--gray-800)'};
    background: none;
    border: none;
    //padding: 0;
    gap: 5px;
    padding-left: 7px;
`

export const ElementList = styled.div`
    display: table;
    table-layout: fixed;
    width: 100%;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    //padding: 12px 8px;
`

export const MenuContainer = styled.div`
    div {
        dt {
            font: 600 16px / 20px var(--font-semibold);
            margin-bottom: 8px;
        }

        dd {
            border-radius: 3px;
            padding: 8px 16px;
            transition: 0.12s;

            :hover {
                background: var(--blue-200);
                cursor: pointer;
                transition: 0.12s;
            }
        }
    }
`

export const SwitchContainer = styled.div`
    :not(:last-child) {
        margin-bottom: 16px;
    }
`

export const EditorElementContainer = styled.div<{ focused: boolean }>`
    padding: 8px;

    :hover {
        background: var(--blue-200);
        transition: 0.12s;
    }
    
    ${({ focused }) =>
        focused &&
        `
        background: var(--blue-200);
    `}}
`

export const EditorAssetsContainer = styled.div`
    padding: 8px;
`

export const PeriodContainer = styled.div`
    display: flex;
    gap: 8px;

    .date-picker {
        input {
            max-width: 143px;
        }
    }

    margin-bottom: 25px;
`
export const StyledList = styled.div`
    li {
        list-style: none;
        padding-bottom: 16px;
    }

    .group-title {
        font-weight: bold;
    }
`
